import api from '@/apis'
import { API_PREFIX } from '@/constants'

/**
 * 밀봉비닐 카카오 간편 결제수단 등록 — POST /payments/methods/webview/kakaopay.
 *
 * 기존 `POST /payments/methods` 의 KAKAOPAY 간편등록을 대체하는 webview 전용 엔드포인트.
 * body 없음. 응답의 `nextRedirectMobileUrl` 로 카카오 등록 페이지를 InAppWebView 안에서 진행하고,
 * 동의 완료 후 백엔드가 webview successURL(`/sealed-vinyl/card-register-callback`)로 redirect 한다.
 */
export interface KakaopayWebviewRegisterResponse {
  tid: string
  nextRedirectMobileUrl: string
  /** PC redirect URL (참고) */
  nextRedirectPcUrl?: string
  /** 카카오톡 앱 redirect URL (참고) */
  nextRedirectAppUrl?: string
  /** Android 카카오톡 deep link (참고) */
  androidAppScheme?: string
  /** iOS 카카오톡 deep link (참고) */
  iosAppScheme?: string
}

export const apiPostKakaopayWebviewRegister = async (): Promise<KakaopayWebviewRegisterResponse> => {
  return api.post(`${API_PREFIX.PAYMENT}/payments/methods/webview/kakaopay`)
}
